{
  "name": "ui-thing",
  "version": "0.2.3",
  "description": "CLI used to add Nuxt components to a project",
  "keywords": [
    "cli",
    "ui",
    "thing",
    "nuxt",
    "reka-ui",
    "tailwindcss",
    "nuxtui",
    "shadcn-ui"
  ],
  "repository": {
    "url": "git+https://github.com/BayBreezy/ui-thing-cli.git"
  },
  "license": "MIT",
  "author": {
    "name": "Behon Baker",
    "email": "behon.baker@yahoo.com",
    "url": "https://behonbaker.com/"
  },
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "bin": {
    "ui-thing": "dist/index.js"
  },
  "scripts": {
    "build": "tsup",
    "clean": "rm -rf dist coverage node_modules package-lock.json && npm install",
    "coverage": "vitest run --coverage",
    "dev": "tsup --watch",
    "format": "npx prettier --write .",
    "knip": "knip",
    "knip:fix": "knip --fix",
    "lint-staged": "lint-staged",
    "prepare": "husky",
    "release": "npm run build && npx changelogen@latest --release && npm publish && git push --follow-tags",
    "start": "node dist/index.js",
    "test": "vitest"
  },
  "lint-staged": {
    "*": [
      "npm run format"
    ]
  },
  "dependencies": {
    "axios": "^1.11.0",
    "boxen": "^8.0.1",
    "c12": "^3.2.0",
    "commander": "^14.0.0",
    "consola": "^3.4.2",
    "dotenv": "^17.2.1",
    "es-toolkit": "^1.39.9",
    "execa": "^9.6.0",
    "figlet": "^1.8.2",
    "fs-extra": "^11.3.1",
    "kleur": "^4.1.5",
    "lodash": "^4.17.21",
    "magicast": "^0.3.5",
    "ora": "^8.2.0",
    "prompts": "^2.4.2"
  },
  "devDependencies": {
    "@ianvs/prettier-plugin-sort-imports": "^4.6.2",
    "@types/figlet": "^1.7.0",
    "@types/fs-extra": "^11.0.4",
    "@types/lodash": "^4.17.20",
    "@types/node": "^24.2.1",
    "@types/prompts": "^2.4.9",
    "@vitest/coverage-v8": "^3.2.4",
    "husky": "^9.1.7",
    "knip": "^5.62.0",
    "lint-staged": "^16.1.5",
    "prettier": "^3.6.2",
    "tsup": "^8.5.0",
    "typescript": "^5.9.2",
    "vitest": "^3.2.4"
  },
  "publishConfig": {
    "access": "public"
  }
}
